var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-8"},[_c('WarningMessage',[_vm._v(" Estamos experimentando una incidencia en el servicio de receta electrónica que esperamos resolver a la mayor brevedad posible. Disculpe las molestias ocasionadas. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }